const SaludoBienvenida = () => {
  return (
    <>
      <h2 className="text-warning"> Bienvenido a nuestra tienda</h2>
    </>
  );
};

export default SaludoBienvenida;
